module.exports = __webpack_public_path__ + "img/2.05fee735.png";